'use strict';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

exports.createCommonjsModule = createCommonjsModule;
//# sourceMappingURL=_commonjsHelpers-6ecf82ef.js.map
